import {
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import {GridComponent} from "@app/modules/shared/components/grid/grid.component";
import {KlLoadingService} from "@app/modules/shared/services/kl-loading.service";
import {ApiService} from "@app/modules/shared/services/base/api.service";
import {UtilService} from "@app/modules/shared/services/util.service";
import {
  ExplorerService,
  ModalConfig,
} from "@app/modules/shared/services/explorer.service";
import {TranslateService} from "@app/modules/shared/services/translate/translate.service";
import {DynamicComponent} from "@app/data/dashboard/interfaces/dynamic-component.interface";
import {ProductLicenseHistoryComponent} from "@dashboard/modules/material-management/product-license/components/product-license-history/product-license-history.component";

@Component({
  selector: "kl-product-license-list",
  templateUrl: "./product-license-list.component.html",
  styleUrls: ["./product-license-list.component.scss"],
})
export class ProductLicenseListComponent implements OnInit, AfterViewInit {
  @Input() mode;
  @Input() tabId: string;
  @Input() modalId: string;
  @Input() templateContext: any;
  @Input() dblSelect = false;
  filterObject: any;
  alertMessage = "";
  alertShow = false;
  alertType = "error";
  @ViewChild(forwardRef(() => GridComponent), {static: true})
  gridComponent: any;
  filterSelectItems = [
    {
      name: "license_key",
      description: "licence_key",
    },
    {
      name: "main_license_key",
      description: "main_license_key",
    },
  ];
  showFilterContainer = false;
  dropdownActions = [
    {
      slug: "created_history",
      method: (cell) => {
        this.alertShow = false;
        this.alertMessage = "";
        this.klLoadingService.show("loading");
        this.gridComponent.alertShow = false;
        this.apiService
          .getHistory("product-license", cell.item.id, "license-history")
          .subscribe(
            (response) => {
              if (response === undefined) {
                this.handleError("error_data");
              } else {
                this.klLoadingService.hide();
                const modalConfig = <ModalConfig>{
                  title:
                    this.translateService.instant("created_history") +
                    " - " +
                    cell.item.license_key,
                  childTemplate: <DynamicComponent>{
                    mode: "DIALOG",
                    modalId: "created-history" + cell.item.id,
                    closeInside: true,
                    template: ProductLicenseHistoryComponent,
                    templateContext: {
                      data: response,
                    },
                  },
                };
                this.explorerService.openModal(modalConfig);
              }
            },
            (error) => this.handleError(error)
          );
      },
    },
  ];

  constructor(
    private klLoadingService: KlLoadingService,
    private apiService: ApiService,
    private utilService: UtilService,
    private translateService: TranslateService,
    private explorerService: ExplorerService
  ) {}

  ngOnInit() {
    this.gridComponent.mode = "DIALOG";
  }
  ngAfterViewInit(): void {
    if (this.dropdownActions.length > 0) {
      this.gridComponent.actions = this.dropdownActions;
    }
  }
  refresh() {
    this.gridComponent.filter(this.gridComponent._filter);
  }

  edit() {
    this.gridComponent.editRecord(this.gridComponent.getCurrentItem());
  }

  toggleFilterContainer() {
    this.showFilterContainer = !this.showFilterContainer;
  }

  filter() {
    this.gridComponent.gridContainerComponent.toggleFilterContainer();
    this.gridComponent.gridContainerComponent.changeDetector.markForCheck();
    this.gridComponent.changeDetector.markForCheck();
  }

  detailFilter() {
    this.gridComponent.onCustomFilter({
      customFilter: true,
      pageSize: this.gridComponent.pageSize,
    });
  }

  exportAs(type) {
    this.gridComponent.onExport(type);
  }

  handleError(error, alertType = "error") {
    this.klLoadingService.hide();
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.alertType = alertType;
    this.alertShow = true;
  }
}
